import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, vModelText as _vModelText, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, resolveDirective as _resolveDirective, isRef as _isRef, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icon/gongdan_ic_shoudong@2x.png'


const _withScopeId = n => (_pushScopeId("data-v-17355da6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tl" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tl_title_left" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "tl_title_left_x" }),
  /*#__PURE__*/_createElementVNode("span", null, "生产点检")
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "增加属性", -1))
const _hoisted_5 = [
  _hoisted_3,
  _hoisted_4
]
const _hoisted_6 = { class: "tl_list" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tl_list_item_label" }, "生产属性", -1))
const _hoisted_9 = { class: "tl_list_item_go" }
const _hoisted_10 = {
  key: 0,
  class: "tl_list_item"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tl_list_item_label" }, "属性值", -1))
const _hoisted_12 = { class: "tl_list_item_go" }
const _hoisted_13 = ["onUpdate:modelValue"]
const _hoisted_14 = {
  key: 1,
  class: "tl_list_item"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tl_list_item_label" }, "属性值", -1))
const _hoisted_16 = { class: "tl_list_item_go" }
const _hoisted_17 = {
  key: 2,
  class: "tl_list_item"
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tl_list_item_label" }, "属性值", -1))
const _hoisted_19 = { class: "tl_list_item_go" }
const _hoisted_20 = {
  key: 3,
  class: "tl_list_item"
}
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tl_list_item_label" }, "属性值", -1))
const _hoisted_22 = { class: "tl_list_item_go" }
const _hoisted_23 = ["onUpdate:modelValue", "placeholder"]
const _hoisted_24 = {
  key: 4,
  class: "tl_list_item"
}
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tl_list_item_label" }, "属性值", -1))
const _hoisted_26 = { class: "tl_list_item_go" }
const _hoisted_27 = ["onUpdate:modelValue", "placeholder"]
const _hoisted_28 = ["onClick"]
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tl_list_item_label" }, "属性值", -1))
const _hoisted_30 = { class: "tl_list_item_go" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tl_zw" }, null, -1))
const _hoisted_32 = { class: "tl_footer" }
const _hoisted_33 = /*#__PURE__*/_createTextVNode("提交")
const _hoisted_34 = [
  _hoisted_33
]

import { ref, onMounted, getCurrentInstance, onBeforeUnmount } from 'vue'
    import { useRoute, useRouter } from "vue-router"
    import { queryById, getJdList, createDJ } from '@/apis/WorkOrderAPI'
    import { Toast } from 'vant'
    import { setTimeO } from '@/utils/utils'
    import VWorkOrderInfo from '@/components/common/WorkOrderInfo.vue'

    
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

    const route = useRoute()

    const router = useRouter()
    const { $Bus }  = getCurrentInstance().appContext.config.globalProperties 

    // 控制日期显示隐藏
    let timer = ref<boolean>(false)

    const minDate: Date = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate() - 1, new Date().getHours(), new Date().getMinutes())

    const maxDate: Date = new Date(new Date().getFullYear() + 1, 12, 30)

    // 属性索引
    let indexs: any = ref<number>()

    let info: any = ref({})

    // 属性信息数组
    let formList: any = ref([
        {
            id: Date.now(),
            attribute: '',       // 属性值
            attributeName: '',   // 属性值名称
            data: '',            // 数据
            type: '',            // 类型
            tips: '',            // 提示子
            num: ''              // 数量
        }
    ])

    // 属性数据
    const gzqjData: any = ref([]);

    const show = ref<boolean>(false)

    // 打开日期插件
    const openTimer = (i: number) => {
        indexs.value = i
        timer.value = true
    }

    // 关闭时间弹框
    const cancelData = () => {
        timer.value = false
    }

    // 日期确认
    const onConfirm = (value: any) => {
        formList.value.forEach((item: any, index: number) => {
            if (indexs.value === index) {
                item.num = setTimeO(value, '-')
            }
        })
        timer.value = false;
    }

    // 打开属性弹框
    const open = (index: number): void => {
        indexs.value = index
        show.value = true
    }

    // 属性确认
    const gzqjConfirm = (value: any): void => {
        formList.value.forEach((item: any, index: number) => {
            if (indexs.value === index) {
                item.attribute = value.id
                item.attributeName = value.text
                item.type = value.type
                item.data = value.data
                item.tips = value.tips
                console.log(value)
                item.num = ''
                if (item.type === 1) {
                    item.num = []
                } else if (item.type === 0) {
                    item.num = item.data[0]
                }
                if (value.type === 4) {
                    formList.value[indexs.value].num = setTimeO(new Date(), '-')
                }
            }
        })
        show.value = false
    }

    // 关闭弹框
    const onCancel = (): void => {
        show.value = false
    }

    // 添加点检信息
    const add = (): void => {
        formList.value.push({ id: Date.now(), attribute: '', attributeName: '', num: '', type: '', data: '', tips: '' })
    }

    // 删除点检信息
    const dele = (index: number): void => {
        if (formList.value.length === 1) {
            Toast('至少保留一条点检信息')
            return
        }
        formList.value.splice(index, 1)
    }

    // 提交点检
    const submit = (): void => {
        let isOpen: any = true

        formList.value.forEach((item: any) => {
            if (item.type === 1) {
                if (item.attribute === '' || item.num.length === 0) {
                    isOpen = false
                }
            } else {
                if (item.attribute === '' || item.num === '') {
                    isOpen = false
                }
            }
        })

        if (isOpen) {
            let attrList: any = []
            formList.value.forEach((item: any) => {
                if (item.type === 1) {
                    attrList.push({ val: item.num.join(' '), attrId: item.attribute })
                } else {
                    attrList.push({ val: item.num, attrId: item.attribute })
                }
            })
            createDJ({
                attrList: attrList,
                id: route.query.id
            }).then(res => {
                if (res.code === 200) {
                    Toast.success({ message: '创建成功', duration: 2000, forbidClick: true })
                    // $Bus.emit('callback1', '1')
                    setTimeout(() => { router.go(-1) }, 2000)
                }
            })
        } else {
            Toast({
                message: '请将信息填写完整',
                duration: 2000
            })
        }
    }

    // 获取详情数据
    const queryByIds = (): void => {
        queryById(route.query.id).then(res => {
            if (res.code === 200) {
                info.value = res.data
            }
        })
    }

    // 属性值数据
    const getJdLists = () => {
        getJdList({ workOrderID: route.query.id })
            .then(res => {
                if (res.code === 200 && res.data && res.data.length !== 0) {
                    res.data.forEach((item: any) => {
                        gzqjData.value.push({ text: item.name, id: item.id, type: item.type, data: item.remark ? item.remark.split(' ') : '', tips: item.tips })
                    })
                }
            })
    }

    onMounted(() => {
        queryByIds()
        getJdLists()
    })

    onBeforeUnmount(() => {
        $Bus.all.delete("callback1")
    })

return (_ctx: any,_cache: any) => {
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_radio = _resolveComponent("van-radio")!
  const _component_van_radio_group = _resolveComponent("van-radio-group")!
  const _component_van_checkbox = _resolveComponent("van-checkbox")!
  const _component_van_checkbox_group = _resolveComponent("van-checkbox-group")!
  const _component_van_button = _resolveComponent("van-button")!
  const _component_van_swipe_cell = _resolveComponent("van-swipe-cell")!
  const _component_van_picker = _resolveComponent("van-picker")!
  const _component_van_popup = _resolveComponent("van-popup")!
  const _component_van_datetime_picker = _resolveComponent("van-datetime-picker")!
  const _directive_preventReClick = _resolveDirective("preventReClick")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(VWorkOrderInfo, { info: _unref(info) }, null, 8, ["info"]),
      _createElementVNode("div", { class: "tl_title" }, [
        _hoisted_2,
        _createElementVNode("div", {
          class: "tl_title_right",
          onClick: add
        }, _hoisted_5)
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(formList), (item, index) => {
        return (_openBlock(), _createBlock(_component_van_swipe_cell, { key: index }, {
          right: _withCtx(() => [
            _createVNode(_component_van_button, {
              square: "",
              style: {"height":"100%"},
              type: "danger",
              text: "删除",
              onClick: ($event: any) => (dele(index))
            }, null, 8, ["onClick"])
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", {
                class: "tl_list_item",
                onClick: ($event: any) => (open(index))
              }, [
                _hoisted_8,
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("span", {
                    style: _normalizeStyle(item.attributeName ? 'color: #000;' : '')
                  }, _toDisplayString(item.attributeName ? item.attributeName : '请选择'), 5),
                  _createVNode(_component_van_icon, {
                    name: "arrow",
                    color: "#999999"
                  })
                ])
              ], 8, _hoisted_7),
              (item.type === '')
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                    _hoisted_11,
                    _createElementVNode("div", _hoisted_12, [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        "onUpdate:modelValue": ($event: any) => ((item.num) = $event),
                        placeholder: "请输入"
                      }, null, 8, _hoisted_13), [
                        [_vModelText, item.num]
                      ])
                    ])
                  ]))
                : (item.type === 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                      _hoisted_15,
                      _createElementVNode("div", _hoisted_16, [
                        _createVNode(_component_van_radio_group, {
                          modelValue: item.num,
                          "onUpdate:modelValue": ($event: any) => ((item.num) = $event),
                          direction: "horizontal"
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.data, (item1, i) => {
                              return (_openBlock(), _createBlock(_component_van_radio, {
                                name: item1,
                                "checked-color": "#4275FC",
                                key: i
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(item1), 1)
                                ]),
                                _: 2
                              }, 1032, ["name"]))
                            }), 128))
                          ]),
                          _: 2
                        }, 1032, ["modelValue", "onUpdate:modelValue"])
                      ])
                    ]))
                  : (item.type === 1)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                        _hoisted_18,
                        _createElementVNode("div", _hoisted_19, [
                          _createVNode(_component_van_checkbox_group, {
                            modelValue: item.num,
                            "onUpdate:modelValue": ($event: any) => ((item.num) = $event),
                            direction: "horizontal"
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.data, (item1, i) => {
                                return (_openBlock(), _createBlock(_component_van_checkbox, {
                                  name: item1,
                                  key: i
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(item1), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["name"]))
                              }), 128))
                            ]),
                            _: 2
                          }, 1032, ["modelValue", "onUpdate:modelValue"])
                        ])
                      ]))
                    : (item.type === 2)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                          _hoisted_21,
                          _createElementVNode("div", _hoisted_22, [
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              "onUpdate:modelValue": ($event: any) => ((item.num) = $event),
                              placeholder: item.tips
                            }, null, 8, _hoisted_23), [
                              [_vModelText, item.num]
                            ])
                          ])
                        ]))
                      : (item.type === 3)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                            _hoisted_25,
                            _createElementVNode("div", _hoisted_26, [
                              _withDirectives(_createElementVNode("input", {
                                type: "text",
                                "onUpdate:modelValue": ($event: any) => ((item.num) = $event),
                                placeholder: item.tips
                              }, null, 8, _hoisted_27), [
                                [_vModelText, item.num]
                              ])
                            ])
                          ]))
                        : (item.type === 4)
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 5,
                              class: "tl_list_item",
                              onClick: ($event: any) => (openTimer(index))
                            }, [
                              _hoisted_29,
                              _createElementVNode("div", _hoisted_30, [
                                _createElementVNode("span", {
                                  style: _normalizeStyle(item.num ? 'color: #000;' : '')
                                }, _toDisplayString(item.num ? item.num : item.tips), 5),
                                _createVNode(_component_van_icon, {
                                  name: "arrow",
                                  color: "#999999"
                                })
                              ])
                            ], 8, _hoisted_28))
                          : _createCommentVNode("", true)
            ])
          ]),
          _: 2
        }, 1024))
      }), 128)),
      _hoisted_31,
      _createElementVNode("div", _hoisted_32, [
        _withDirectives((_openBlock(), _createElementBlock("button", {
          class: "tl_footer_submit",
          onClick: submit
        }, _hoisted_34)), [
          [_directive_preventReClick]
        ])
      ])
    ]),
    _createVNode(_component_van_popup, {
      show: show.value,
      "onUpdate:show": _cache[0] || (_cache[0] = ($event: any) => ((show).value = $event)),
      position: "bottom",
      round: "",
      style: { height: '50%' }
    }, {
      default: _withCtx(() => [
        _createVNode(_component_van_picker, {
          title: "选择生产属性",
          columns: gzqjData.value,
          onConfirm: gzqjConfirm,
          onCancel: onCancel
        }, null, 8, ["columns"])
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(_component_van_popup, {
      show: _unref(timer),
      "onUpdate:show": _cache[1] || (_cache[1] = ($event: any) => (_isRef(timer) ? (timer).value = $event : timer = $event)),
      position: "bottom",
      style: { height: '50%' }
    }, {
      default: _withCtx(() => [
        _createVNode(_component_van_datetime_picker, {
          type: "datetime",
          title: "请选择时间",
          "min-date": _unref(minDate),
          "max-date": _unref(maxDate),
          onConfirm: onConfirm,
          onCancel: cancelData
        }, null, 8, ["min-date", "max-date"])
      ]),
      _: 1
    }, 8, ["show"])
  ], 64))
}
}

})